import { createRouter, createWebHistory } from "vue-router";

import DashboardEdit from "./pages/dashboard-edit/dashboard-edit.vue";
import Dashboard from "./pages/dashboard/dashboard-page.vue";
import Login from './pages/login-page.vue';
import ResetPassword from '~/pages/reset-password-page.vue';
import Forbidden from '~/pages/forbidden-page.vue';
import AdvancedView from '~/pages/advanced-view/advanced-view-page.vue';
import Preferences from '~/pages/preferences/preferences-page.vue';
import NotFound from '~/pages/not-found-page.vue';
import AddStation from "./pages/add-station-page.vue";

import { useAuthStore } from "./store/auth.store";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", redirect: "/dashboard" },
    { path: "/dashboard", component: Dashboard, name: 'dashboard', meta: { requireAuth: true, headbar: true } },
    { path: "/add-station", component: AddStation, name: 'add-station', meta: { requireAuth: true, headbar: true } },
    { path: "/dashboard/edit", component: DashboardEdit, name: 'dashboard-edit', meta: { requireAuth: true, headbar: true } },
    { path: '/advanced-view', component: AdvancedView, name: 'advanced-view', meta: { requireAuth: true, headbar: true } },
    { path: '/preferences', component: Preferences, name: 'preferences', meta: { requireAuth: true, headbar: true } },
    { path: '/login', component: Login, name: 'login', meta: { requireAuth: false, headbar: false } },
    { path: '/reset-password', component: ResetPassword, name: 'reset-password', meta: { requireAuth: false, headbar: false } },
    { path: '/403', component: Forbidden, name: 'forbidden', meta: { requireAuth: false, headbar: true } },
    { path: '/:pathMatch(.*)*', name: 'not-found', component: NotFound, meta: { requireAuth: false, headbar: true } },
  ],
  linkActiveClass: 'is-active',
  linkExactActiveClass: 'is-active',
});

router.beforeEach((to) => {
  const authStore = useAuthStore();
  if(to.meta.requireAuth && !authStore.isLogged) {
    return '/login'
  }

});

export default router;
